import React, { ChangeEvent, FC } from "react";
import TEXT from "../../../text-consts";
import { Input } from "../../../../forms";

export interface KeepNumberPanelProps {
    choosePhoneNumber: (phoneNumber: string, isSubscriptionBroadband: boolean) => void;
    disabled: boolean;
    isSubscriptionBroadband: boolean;
    isValidPhoneNumber: boolean;
    labelId: string;
    placeholder?: string;
    selectedPhoneNumber: string;
}

const KeepNumberPanel: FC<KeepNumberPanelProps> = ({
    choosePhoneNumber,
    labelId,
    selectedPhoneNumber,
    isSubscriptionBroadband,
    placeholder,
    disabled,
    isValidPhoneNumber,
}) => (
    <Input
        id="retailer-keep-number-input"
        aria-labelledby={labelId}
        type="tel"
        value={selectedPhoneNumber}
        onChange={(event: ChangeEvent<HTMLInputElement>) =>
            choosePhoneNumber(event.target.value, isSubscriptionBroadband)
        }
        placeholder={placeholder || TEXT.PERSONAL_DETAILS.PHONENUMBER.YOUR_NUMBER}
        data-di-mask
        disabled={disabled}
        label="Fyll inn mobilnummer"
        success={isValidPhoneNumber}
    />
);

export default KeepNumberPanel;
